/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Meta_TitleInputs */

const en_pc_cmp_meta_title = /** @type {(inputs: Pc_Cmp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft vs Adobe Acrobat (2026): Price, Features & Differences`)
};

const zh_pc_cmp_meta_title = /** @type {(inputs: Pc_Cmp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 与 Adobe Acrobat 对比（2026）：价格、功能与区别`)
};

/**
* | output |
* | --- |
* | "PdfCraft vs Adobe Acrobat (2026): Price, Features & Differences" |
*
* @param {Pc_Cmp_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_meta_title = /** @type {((inputs?: Pc_Cmp_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_meta_title(inputs)
	return zh_pc_cmp_meta_title(inputs)
});
export { pc_cmp_meta_title as "pc.cmp.meta_title" }